import { encodeAccountID } from '@exodus/ripple-address-codec'
import BN from 'bn.js'

import { sha512half } from '../crypto.js'

const HASH_PREFIX = Buffer.from('54584E00', 'hex')

export function getHash(buffer) {
  return sha512half(HASH_PREFIX, buffer).toString('hex').toUpperCase()
}

// Used by trezor
export function fromBuffer(txBuf) {
  let i = 0

  function readFromBuffer(length) {
    if (!(typeof length === 'number' && length >= 0)) throw new Error('length must be a number')
    const sliced = txBuf.slice(i, i + length)
    if (sliced.length !== length) throw new Error('Did not have enough data to slice')
    i += length
    return sliced
  }

  function readIntFromBuffer(size) {
    return new BN(readFromBuffer(size), 'be')
  }

  function assertMatchesHex(length, hex) {
    if (!(typeof length === 'number' && length >= 0)) throw new Error('length must be a number')
    const slicedHex = txBuf.hexSlice(i, i + length)
    i += length
    if (hex !== slicedHex) {
      throw new Error(`invalid TX buffer - actual [${slicedHex}] did not match expected [${hex}]`)
    }
  }

  let signed = true
  const txObj = {}

  // flag indicates absence of signature
  if (txBuf.hexSlice(i, i + 4) === '53545800') {
    signed = false
    i += 4
  }

  // TransactionType
  assertMatchesHex(3, '120000') // field name/value
  txObj.TransactionType = 'Payment' // Only type supported

  // Flags
  assertMatchesHex(1, '22')
  txObj.Flags = readIntFromBuffer(4).toNumber()

  // Sequence
  assertMatchesHex(1, '24')
  txObj.Sequence = readIntFromBuffer(4).toNumber()

  // DestinationTag
  if (txBuf.hexSlice(i, i + 1) === '2e') {
    i += 1
    txObj.DestinationTag = readIntFromBuffer(4).toNumber()
  }

  // LastLedgerSequence
  assertMatchesHex(2, '201b')
  txObj.LastLedgerSequence = readIntFromBuffer(4).toNumber()

  // Amount
  assertMatchesHex(2, '6140')
  txObj.Amount = readIntFromBuffer(7).toString(10)

  // Fee
  assertMatchesHex(2, '6840')
  txObj.Fee = readIntFromBuffer(7).toString(10)

  // SigningPubKey
  assertMatchesHex(1, '73')
  const pkLength = readIntFromBuffer(1).toNumber()
  txObj.SigningPubKey = readFromBuffer(pkLength).toString('hex').toUpperCase()

  // TxnSignature
  if (signed) {
    assertMatchesHex(1, '74')
    const sigLength = readIntFromBuffer(1).toNumber()
    txObj.TxnSignature = readFromBuffer(sigLength).toString('hex').toUpperCase()
  }

  // Account
  assertMatchesHex(2, '8114')
  const senderAccountBytes = readFromBuffer(20)
  txObj.Account = encodeAccountID(senderAccountBytes)

  // Destination
  assertMatchesHex(2, '8314')
  const destAccountBytes = readFromBuffer(20)
  txObj.Destination = encodeAccountID(destAccountBytes)

  return txObj
}
